import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/nuestras-oficinas")({
  head: () => buildRouteHead("/es/nuestras-oficinas", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/contacto", replace: true });
  },
});
